import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsAboutLiteLazy = loadable(
    () => import(/* webpackChunkName: "Lite.SettingsAbout" */ './SettingsAboutLiteSuspense')
);

export const SettingsAboutLiteAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsAboutLiteLazy />
    </DelayedSuspense>
);
